import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Create a Spellingframe account", -1)
const _hoisted_2 = { class: "sm:tw-grid sm:tw-grid-cols-2 sm:tw-gap-8" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "tw-font-bold" }, "Parent Information", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, " First Name* ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, " Last Name* ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, " Email address* ", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, " Confirm email address* ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", { class: "tw-font-bold" }, "Student Information", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, " First Name* ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, " Last Name* ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, " Subscriptions ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-4" }, [
  /*#__PURE__*/_createTextVNode(" I have read, understood, and agree to the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/sitemedia/Spellingframe_Terms_and_Conditions_FULL_v1.pdf",
    target: "sf_tos"
  }, "terms and conditions")
], -1)
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountShortDescription = _resolveComponent("AccountShortDescription")!
  const _component_ContactLink = _resolveComponent("ContactLink")!
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!
  const _component_RegisterResume = _resolveComponent("RegisterResume")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_IndividualPurchaseField = _resolveComponent("IndividualPurchaseField")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RegisterResume, null, {
        title: _withCtx(() => [
          _createTextVNode(" Single User Accounts ")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_AccountShortDescription, { type: "individual" })
        ]),
        switch: _withCtx(() => [
          (_ctx.mfTokenData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(" If you would prefer to register as a school please "),
                _createVNode(_component_ContactLink),
                _createTextVNode(" for further assistance. ")
              ]))
            : (_openBlock(), _createBlock(_component_SfRouterLink, {
                key: 1,
                to: '/register/school'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Switch to school account ")
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createElementVNode("form", {
          ref: "registerForm",
          onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("fieldset", {
            disabled: _ctx.status == 'loaded'
          }, [
            _createElementVNode("div", null, [
              _hoisted_5,
              _createVNode(_component_FormInput, {
                modelValue: _ctx.formData.fields.parentFirstName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.fields.parentFirstName) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.fields.parentFirstName.value) = $event)),
                    class: "sf-form-control tw-w-full"
                  }, null, 512), [
                    [_vModelText, _ctx.formData.fields.parentFirstName.value]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_FormInput, {
                modelValue: _ctx.formData.fields.parentLastName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.fields.parentLastName) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.fields.parentLastName.value) = $event)),
                    class: "sf-form-control tw-w-full"
                  }, null, 512), [
                    [_vModelText, _ctx.formData.fields.parentLastName.value]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_FormInput, {
                modelValue: _ctx.formData.fields.parentEmail,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.fields.parentEmail) = $event)),
                "prevent-error-wrap": false,
                "custom-errors": {
                exists: 'A school user with this email already exists. Please use a different email address or contact us if you need to register with this email address.',
              }
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  (_ctx.mfTokenData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.formData.fields.parentEmail.value), 1))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.fields.parentEmail.value) = $event)),
                        class: "sf-form-control tw-w-full"
                      }, null, 512)), [
                        [_vModelText, _ctx.formData.fields.parentEmail.value]
                      ])
                ]),
                _: 1
              }, 8, ["modelValue", "custom-errors"]),
              (!_ctx.mfTokenData)
                ? (_openBlock(), _createBlock(_component_FormInput, {
                    key: 0,
                    modelValue: _ctx.formData.fields.parentEmailConfirm,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.fields.parentEmailConfirm) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.fields.parentEmailConfirm.value) = $event)),
                        class: "sf-form-control tw-w-full"
                      }, null, 512), [
                        [_vModelText, _ctx.formData.fields.parentEmailConfirm.value]
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _hoisted_11,
              _createVNode(_component_FormInput, {
                modelValue: _ctx.formData.fields.first_name,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.fields.first_name) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.fields.first_name.value) = $event)),
                    class: "sf-form-control tw-w-full"
                  }, null, 512), [
                    [_vModelText, _ctx.formData.fields.first_name.value]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_FormInput, {
                modelValue: _ctx.formData.fields.last_name,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.fields.last_name) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.fields.last_name.value) = $event)),
                    class: "sf-form-control tw-w-full"
                  }, null, 512), [
                    [_vModelText, _ctx.formData.fields.last_name.value]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (_ctx.isMathsAvailable)
              ? (_openBlock(), _createBlock(_component_FormInput, {
                  key: 0,
                  modelValue: _ctx.formData.fields.products,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.fields.products) = $event)),
                  "custom-errors": {
              minLength: 'You must select at least one subscription',
            }
                }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    _createVNode(_component_IndividualPurchaseField, {
                      modelValue: _ctx.formData.fields.products.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.fields.products.value) = $event)),
                      class: "sf-label-light"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4),
          _hoisted_15,
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "submit",
              disabled: _ctx.status == 'loaded',
              class: "sf-btn-primary"
            }, " Register ", 8, _hoisted_16)
          ])
        ], 544)
      ])
    ])
  ], 64))
}